import { Sparkles, X } from "lucide-react";
import { toast } from "sonner";

import { Button, ScrollArea } from "@/components/ui";
import { useIsDemo } from "@/hooks/common/useIsDemo";
import { VAULT_AI_SUGGESTIONS } from "@/mockData/vaultNav";

interface VaultAriPanelProps {
  onClose: () => void;
}

export function VaultAriPanel({ onClose }: VaultAriPanelProps) {
  // Route-authoritative: the fabricated suggestion counts ("23 unfiled
  // contracts", "Move 312 stale files") are SHOWCASE fixtures for /demo/*. On a
  // real route there is no suggestion engine yet, so show an honest empty state
  // rather than counts that don't match the user's actual files.
  const isDemo = useIsDemo();
  const suggestions = isDemo ? VAULT_AI_SUGGESTIONS : [];

  return (
    <aside className="flex w-80 shrink-0 flex-col overflow-hidden border-l border-border">
      <div className="flex items-center justify-between border-b border-border px-4 py-3">
        <div className="flex items-center gap-2">
          <span className="">
            Ari Suggestions
          </span>
        </div>
        <Button variant="ghost" size="icon-sm" onClick={onClose} aria-label="Close Ari panel">
          <X className="size-4" />
        </Button>
      </div>

      <ScrollArea className="min-h-0 flex-1 p-3">
        {suggestions.length === 0 ? (
          <div className="flex h-full flex-col items-center justify-center gap-2 px-4 py-10 text-center">
            <Sparkles className="size-6 text-muted-foreground" aria-hidden="true" />
            <p className="text-sm font-medium text-foreground">No suggestions yet</p>
            <p className="text-xs leading-relaxed text-muted-foreground">
              Ari will surface ways to organize your files as your vault fills up.
            </p>
          </div>
        ) : (
          <div className="space-y-2">
            {suggestions.map((s) => (
              <div key={s.id} className="rounded-2xl bg-muted/50 p-3">
                <p className="text-sm font-medium text-foreground">{s.title}</p>
                <p className="mt-1 text-xs leading-relaxed text-muted-foreground">{s.detail}</p>
                <Button
                  size="sm"
                  variant="outline"
                  className="mt-2 h-7 text-xs"
                  onClick={() => toast.info(`${s.action} is coming soon`)}
                >
                  {s.action} ({s.count})
                </Button>
              </div>
            ))}
          </div>
        )}
      </ScrollArea>
    </aside>
  );
}
